import { Routes } from '@angular/router';
import { TimesheetDetailsComponent } from '@timesheet/details/details.component';
import { TimesheetListComponent } from '@timesheet/list/list.component';
import { TimesheetComponent } from '@timesheet/timesheet.component';
import { canDeactivateTimesheetDetails, timesheetResolver, timesheetsResolver } from '@timesheet/timesheet.resolver';

export default [
  {
    path: '',
    component: TimesheetComponent,
    resolve: {},
    children: [
      {
        path: '',
        component: TimesheetListComponent,
        resolve: {
          requests: timesheetsResolver
        },
        children: [
          {
            path: ':id',
            component: TimesheetDetailsComponent,
            resolve: {
              timesheet: timesheetResolver
            },
            canDeactivate: [canDeactivateTimesheetDetails]
          }
        ]
      }
    ]
  }
] as Routes;
